const pendingChanges = new WeakMap();

// i18next language changes cannot be aborted. Share their order across startup
// and OAuth so an old session's late download never replaces the new language.
export default async function changeLanguageInOrder(i18n, language, isCurrent) {
  const changing = (pendingChanges.get(i18n) || Promise.resolve())
    .catch(() => undefined)
    .then(() => isCurrent() ? i18n.changeLanguage(language) : undefined);
  pendingChanges.set(i18n, changing);
  try {
    await changing;
  } finally {
    if (pendingChanges.get(i18n) === changing) pendingChanges.delete(i18n);
  }
}
